import {React} from "react";

import './Footer2.scss'
import JButton from '../../components/Button/JButton'

const  Footer2= () => {
    return ( 
        <div className="footerr">
           <div  className="callingg">
                <label className="fa fa-phone fa-rotate-270"></label>
                <div>شماره تماس : </div>
                <span>
                    <a href="tel:1514" target="_blank">۱۵۱۴</a>
                </span>
            </div>
            <div className="divcop">
                استفاده از کارت هدیه یا کارت تخفیف در صفحه پرداخت امکان پذیر می باشد.
            </div>
        </div>
     );
}

export default Footer2;
